import { DesktopStatusPill } from '@crowdex/ui/components/desktop';
import { LoaderCircle } from 'lucide-react';

export type DesktopConnectionState =
  | 'authenticating'
  | 'error'
  | 'idle'
  | 'on-demand'
  | 'ready'
  | 'starting';

export function DesktopConnectionStatus({ state }: { state: DesktopConnectionState }) {
  if (state === 'ready') return null;

  return (
    <DesktopStatusPill>
      {state === 'starting' || state === 'authenticating' ? (
        <>
          <LoaderCircle className="size-3 animate-spin" />
          {state === 'authenticating' ? 'Authenticating' : 'Starting'}
        </>
      ) : state === 'on-demand' ? (
        <>
          <span className="size-1.5 rounded-full bg-desktop-success" /> Cloud on demand
        </>
      ) : (
        <>
          <span className="size-1.5 rounded-full bg-muted-foreground" /> Offline
        </>
      )}
    </DesktopStatusPill>
  );
}
